<template>
  <transition name="modal">
    <div class="modal-mask">
      <a
        class="modal-close"
        aria-label="Close"
        @click="$emit('close')"
      >
        <img
          :src="asset('/images/close.png')"
          width="35px"
        > </a>

      <div class="modal-wrapper">
        <div class="modal-container mobile">
          <div class="modal-header">
            <h4 class="modal-title">
              Supported devices
            </h4>
          </div>

          <div class="modal-body">
            <p>
              The SECCA App has been created to be used on a tablet device or computer, and is not supported on mobile phone devices. 
              Visit the help section on the App Website for more information.
            </p>
          </div>

          <div class="modal-footer full-width">
            <div class="col-md-6">
              <!--<a href="#" class="btn btn-success btn-lg btn-block">Supported devices</a>-->
            </div>
            <div class="col-md-6">
              <a
                href="https://app.secca.org.au/help/"
                target="_blank"
                class="btn btn-success btn-lg btn-block"
              >
                Further Help
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
module.exports = {
  name: 'Browser'
}
</script>
